export const TEXT_CONSTANTS = {
  title: "Compliance Dashboard",
};
export const getChartData = (filteredData) => {
  if (!filteredData.length) return [];

  const listOfDataKeys = Object.keys(filteredData[0]);

  return category
    .filter(({ value }) => listOfDataKeys.includes(value))
    .map(({ label, value }) => ({
      categoryName: label,
      completed: filteredData.filter((data) => data[value]).length,
      notCompleted: filteredData.filter((data) => !data[value]).length,
      totalUser: filteredData.length,
      type: value,
    }));
};

export const getListOfYears = (filteredData) => {
  return filteredData
    .map((data) => {
      return {
        value: data.year,
        label: data.year,
      };
    })
    .reduce((acc, current) => {
      if (!acc.some((years) => years.value === current.value)) {
        acc.push(current);
      }
      return acc;
    }, []);
};
export const getListOfQuarters = (filteredData) => {
  return filteredData
    .map((data) => {
      return {
        value: data.quarter,
        label: quaters[data.quarter],
      };
    })
    .reduce((acc, current) => {
      if (!acc.some((quarter) => quarter.value === current.value)) {
        acc.push(current);
      }
      return acc;
    }, []);
};

export const complianceTableData = [
  {
    year: "2024",
    quarter: "Q1",
    employeeId: "E201",
    employeeName: "Frank Green",
    vdi: false,
    skillRepository: false,
  },
  {
    year: "2024",
    quarter: "Q2",
    employeeId: "E202",
    employeeName: "Grace Hall",
    vdi: true,
    vdiSubmissionDate: "2024-03-17T12:30:45Z",
    skillRepository: true,
    skillRepositorySubmissionDate: "2024-03-16T14:15:30Z",
  },
  {
    year: "2024",
    quarter: "Q3",
    employeeId: "E203",
    employeeName: "Henry King",
    vdi: true,
    vdiSubmissionDate: "2024-03-17T10:00:00Z",
    skillRepository: true,
    skillRepositorySubmissionDate: "2024-03-15T09:45:00Z",
  },
  {
    year: "2024",
    quarter: "Q4",
    employeeId: "E204",
    employeeName: "Ivy Lewis",
    vdi: false,
    skillRepository: false,
  },
  {
    year: "2025",
    quarter: "Q1",
    employeeId: "E101",
    employeeName: "Alice Johnson",
    vdi: true,
    vdiSubmissionDate: "2024-03-17T12:30:45Z",
    skillRepository: true,
    skillRepositorySubmissionDate: "2024-03-16T14:15:30Z",
  },
  {
    year: "2025",
    quarter: "Q1",
    employeeId: "E102",
    employeeName: "Bob Smith",
    vdi: false,
    skillRepository: false,
  },
  {
    year: "2025",
    quarter: "Q2",
    employeeId: "E103",
    employeeName: "Charlie Brown",
    vdi: true,
    vdiSubmissionDate: "2024-03-17T12:00:00.123Z",
    skillRepository: false,
  },
  {
    year: "2025",
    quarter: "Q3",
    employeeId: "E104",
    employeeName: "David White",
    vdi: false,
    skillRepository: true,
    skillRepositorySubmissionDate: "2024-03-15T09:45:00Z",
  },
  {
    year: "2025",
    quarter: "Q4",
    employeeId: "E105",
    employeeName: "Eve Green",
    vdi: false,
    skillRepository: false,
  },
];

export const category = [
  { value: "skillRepository", label: "Skill Repository" },
  { value: "vdi", label: "VDI Compliance" },
];
export const quaters = {
  Q1: "Jan - Mar",
  Q2: "Apr - Jun",
  Q3: "Jul - Sep",
  Q4: "Oct - Dec",
};

export const getCurrentQuarter = ()=>{
  const date = new Date();     
 return `Q${parseInt(date.getMonth() / 3 ) + 1}`
} 
export const getCurrentYear = ()=>{
  const date = new Date();     
 return date.getFullYear().toString()
} 
